import { observer } from 'mobx-react-lite';
import SyntaxHighlighter from '@fengkx/react-syntax-highlighter';
import { atomOneDark } from '@fengkx/react-syntax-highlighter/dist/esm/styles/hljs';
import Markdown from '@/components/markdown';
import '../index.scss'; // 引入样式

const Code = observer(props => {
  const { data, className, syntaxClassName = '', light = true, showLineNumbers = false } = props;

  return (
    <div className={[
      'text-black rounded-b-4px',
      'overflow-x-hidden overflow-y-auto scrollbar',
      light ? 'bg-white scrollbar-light' : 'bg-[#282c34] scrollbar-dark',
      className,
    ]}>
      <Markdown
        typing={false}
        text={data}
        components={{
          code({ node, inline, className, children, ...props }) {
            const LANGUAGE_RE = /language-(\w+)/;
            const match = LANGUAGE_RE.exec(className);
            if (match) {
              return (
                <SyntaxHighlighter
                  {...props}
                  wrapLongLines={false} // 不换行
                  className={[
                    'text-[12px] leading-relaxed break-words',
                    syntaxClassName,
                    'scrollbar-dark', // 底部横向滚动条
                  ]}
                  style={{  
                    ...light ? {} : atomOneDark,
                  }}
                  customStyle={{
                    fontFamily: 'SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace', 
                  }}
                  showLineNumbers={showLineNumbers}
                  children={String(children).replace(/\n$/, '')}
                  language={match[1]}
                  PreTag="div"
                />
              );
            }
          },
        }}
      />
    </div>
  );
});

export default Code;
